<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('animal.Note') }}</h5>
    <p class="mb-0 text-sm">{{ $t('animal.Optional_information') }}</p>
    <div class="multisteps-form__content">
      <div class="row mt-3">
        <div class="col-12">                     
            <textarea
              v-model="localFormData.notes"
              class="form-control custom-textarea"
              style="border: 1px solid #ced4da;"
              rows="5"
            ></textarea>
        </div>
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="this.$parent.prevStep">{{ $t('common.Prev') }}</button>
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto js-btn-next" type="button" @click="validateAndNextStep">{{ $t('common.Next') }}</button>                
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import { reactive, watch } from 'vue'

  export default {
    name: "NoteSection",
    props: {
      formData: Object,
      nextStep: Function
    },
    setup(props, { emit }) {

      const localFormData = reactive({ ...props.formData })

      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })

      const validateAndNextStep = async () => {
          props.nextStep()
      }

      return {
        localFormData,
        validateAndNextStep
      }
    }    
};
</script>
<style scoped>
.custom-textarea {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 0.5rem;  
}
</style>